import React from "react";
import { CheckCircle, Cancel } from "@mui/icons-material";
import { Box } from "@mui/material";
import RecordedContactActionCell from "./RecordedContactActionCell";

export function getRecordedContactColumns(onEditContact) {
  const actionsColumn = {
    field: "actions",
    headerName: "Actions",
    width: 100,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <RecordedContactActionCell
        id={params.row.id}
        row={params.row}
        onEditContact={onEditContact}
      />
    ),
  };

  return [
    { field: "id", headerName: "ID", flex: 0.5, minWidth: 80 },
    {
      field: "internalId",
      headerName: "Employee Number",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "fullName",
      headerName: "Employee Fullname",
      flex: 1.2,
      minWidth: 180,
    },
    {
      field: "email",
      headerName: "Employee Email Address",
      flex: 1.5,
      minWidth: 220,
    },
    {
      field: "identifiers",
      headerName: "Identifiers",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const endpoints = params.row.endpoints || [];
        const identifiers = endpoints.map((ep) => ep.identifier).join(", ");
        return <span>{identifiers || <em>No endpoints</em>}</span>;
      },
    },
    {
      field: "nextCompetencyReviewDueAt",
      headerName: "Next Competency Review Due",
      flex: 1.2,
      minWidth: 160,
      renderCell: (params) => {
        return params.value ? params.value : "Not Yet Reviewed";
      },
    },
    {
      field: "isActive",
      headerName: "Active",
      flex: 0.5,
      minWidth: 80,
      type: "boolean",
      renderCell: (params) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          {params.value ? (
            <CheckCircle color="success" />
          ) : (
            <Cancel color="error" />
          )}
        </Box>
      ),
    },
    {
      field: "sentinelNumber",
      headerName: "Sentinel Number",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "competence",
      headerName: "Competence",
      flex: 1.2,
      minWidth: 180,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "function",
      headerName: "Function",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "route",
      headerName: "Route",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "area",
      headerName: "Area",
      flex: 1.2,
      minWidth: 180,
    },
    {
      field: "empCompFrom",
      headerName: "Emp Comp From",
      flex: 1.2,
      minWidth: 160,
      type: "dateTime",
      valueGetter: (params) => {
        if (!params || !params.value) return null;
        return new Date(params.value);
      },
    },
    {
      field: "empCompValidUntil",
      headerName: "Emp Comp Valid Until",
      flex: 1.2,
      minWidth: 160,
      type: "dateTime",
      valueGetter: (params) => {
        if (!params || !params.value) return null;
        return new Date(params.value);
      },
    },
    {
      field: "supervisorEmployeeNumber",
      headerName: "Supervisor Employee Number",
      flex: 1.2,
      minWidth: 180,
    },
    {
      field: "supervisorName",
      headerName: "Supervisor Name",
      flex: 1.2,
      minWidth: 180,
    },
    {
      field: "supervisorEmail",
      headerName: "Supervisor Email",
      flex: 1.5,
      minWidth: 220,
    },
    {
      field: "costCentre",
      headerName: "Cost Centre",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "organisation",
      headerName: "Organisation",
      flex: 1.2,
      minWidth: 180,
    },
    {
      field: "supervisorMvrRole",
      headerName: "Supervisor MVR Role",
      flex: 1.2,
      minWidth: 160,
    },
    {
      field: "retentionPolicy",
      headerName: "Retention Policy",
      flex: 1.2,
      minWidth: 160,
    },
    {
      ...actionsColumn,
      flex: 1,
      minWidth: 140,
    },
  ];
}
